
define('ldsh!modules/form_editor/templates/editor_dropdown', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-form-group">\n  <div class="md__checkbox--wrapper">\n     <input\n      id="first-value-not-valid"\n      type="checkbox"\n      class="md__checkbox--primary js-filter-hidden js-first"\n      ' +
((__t = ( firstOptionInvalid ? 'checked': '' )) == null ? '' : __t) +
'\n    />\n    <label\n      for="first-value-not-valid"\n      data-i18n="formEditor.dropDownFirstValueInvalid"\n    ></label>\n  </div>\n</div>\n<h4 data-i18n="formEditor.elementsTitle">Elementos</h4>\n<div class="js-items"></div>\n';

}
return __p
};});

